import { defineMessages } from 'react-intl';

import { addAndRemoveObjectsFromArray } from '../../../helpers';

import Default from './Default';

defineMessages({
  defaultVariation: {
    id: 'Default',
    defaultMessage: 'Default',
  },
});

const removedDefaultVariations = ['default'];

const teaserVariations = [
  {
    id: 'gov',
    isDefault: true,
    title: 'Gov',
    template: Default,
  },
];

const applyConfig = (config) => {
  config.blocks.blocksConfig.teaser.variations = addAndRemoveObjectsFromArray(
    config.blocks.blocksConfig.teaser.variations,
    teaserVariations,
    removedDefaultVariations,
  );

  return config;
};

export default applyConfig;
